export default __webpack_public_path__ + "static/media/idlib.ca7a8e7e.jpg";